<template>
  <section class="ugc-design-view">
    <section class="ugc-design-view-wrapper">
      <base-spinner></base-spinner>
      <fabric-canvas name="fabCanvas" ref="fabCanvas">
        <gcc-auto-update></gcc-auto-update>
        <placement-mask @placement-loaded="onPlacementLoaded" />
        <uploaded-image @image-loaded="onUploadedImageLoaded"></uploaded-image>
      </fabric-canvas>
    </section>
    <ugc-tools></ugc-tools>
  </section>
</template>

<script>
import baseSpinner from '@/components/Spinner';
import ugcTools from '@/components/UGC/Tools/UgcTools';
import fabricCanvas from '@/components/UGC/FabricCanvas';
import placementMask from '@/components/UGC/PlacementMask';
import uploadedImage from '@/components/UGC/UploadedImage';
import gccAutoUpdate from '@/components/UGC/GccAutoUpdate';

export default {
  name: "UgcDesignView",
  components: {
    baseSpinner,
    ugcTools,
    fabricCanvas,
    placementMask,
    uploadedImage,
    gccAutoUpdate
  },
  data() {
    return {
      placementLoaded: false,
      uploadedImageLoaded: false,
      wasReplaceTool: false
    };
  },
  computed: {
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    activeUGCIndex() {
      return this.$store.state.ugc.tempData.activeUGCIndex;
    },
    tempRecipe() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].recipe;
    },
    ugcFeature() {
      return this.$store.state.ugc.tempData.features[this.activeUGCIndex].ugcFeature;
    }
  },
  methods: {
    setCanvasInStore() {
      const { tempData } = this.$store.state.ugc;
      const {
        activeUGCComponent: componentName
      } = tempData.features[tempData.activeUGCIndex];
      this.$refs.fabCanvas
        .getCanvas()
        .then(canvas => {
          if (
            !tempData.features[tempData.activeUGCIndex].uploadAnother &&
            !tempData.features[tempData.activeUGCIndex].selectAnother &&
            tempData.features[tempData.activeUGCIndex].storeMultipleUGCsizes &&
            !this.wasReplaceTool &&
            !this.$store.getters["utils/isGCC"] &&
            !this.$ugc.isUGCFromSwatch(this.recipe_v2.components[componentName].swatch_id) &&
            this.tempRecipe.components[componentName] &&
            this.tempRecipe.components[componentName].ugc
          ) {
            let { ugc: ugcObject } = this.recipe_v2.components[componentName];
            const {  image_url } = this.ugcFeature ? ugcObject.placements[0] : ugcObject.original_image;
            return this.$store
              .dispatch("ugc/SET_CANVAS_IMAGE", {
                fabricCanvas: canvas,
                imageSrc: image_url,
              })
              .then(() => Promise.resolve(canvas))
              .catch(Promise.reject);
          }
          return Promise.resolve(canvas);
        })
        .then(canvas => {
          this.$store.dispatch("ugc/stateManager/INIT", canvas);
          this.$eventBus.$emit("image-set");
          // Make first visible button focusable after image is set.
          document.querySelector('.v--modal button:not([style*="display: none"])').focus();
          this.$eventBus.$emit("hide-customs-spinner", true);
          this.$store.commit("ugc/stateManager/SET_LOADING", false);
          if (!this.$store.getters['utils/useEcomDataLayerFormat']) {
            dataLayer.push({
              ugcStep: `setPlacement1`,
              timeStamp: new Date().toISOString(),
              event: "ugcStep",
              eventCategory:'customs',
              eventAction:'UGC',
              eventLabel: `setPlacement1`,
            });
          }
          this.$store.commit("ugc/stateManager/SET_LOADING", this.$store.getters["ugc/tempData/getPlacementViewOrder"] !== 0);
        });
    },
    onPlacementLoaded() {
      this.placementLoaded = true;
      if (
        this.uploadedImageLoaded &&
        !this.$store.state.ugc.stateManager.canvas
      ) {
        this.setCanvasInStore();
      }
    },
    onUploadedImageLoaded() {
      this.uploadedImageLoaded = true;
      if (this.placementLoaded && !this.$store.state.ugc.stateManager.canvas) {
        this.setCanvasInStore();
      }
    }
  },
  created() {

    this.wasReplaceTool = this.$store.state.ugc.stateManager.activeControl === "ugc-replace-image-control";
    this.$store.commit("ugc/stateManager/SET_LOADING", true);
    this.$eventBus.$emit("hide-next-button", false);
    this.$emit('showIconButton', true);
    const { tempData } = this.$store.state.ugc;
    if (this.wasReplaceTool && tempData.features[tempData.activeUGCIndex].storeMultipleUGCsizes) {
      const sizes = this.$store.state.buyPanel.itemsToPurchase;
      this.$store.commit("ugc/tempData/SET_UGC_SIZE", sizes[sizes.length - 1].size);
    }
  }
};
</script>
